import PnlCreatePage from "@Quest/Pnls/Pages/PnlCreatePage.vue";
import PnlEditPage from "@Quest/Pnls/Pages/PnlEditPage.vue";
import PnlsPage from "@Quest/Pnls/Pages/PnlsPage.vue";

export const routes = [
    {
        path: "/enterprise/pnls/:workspaceId/:strategyId",
        component: PnlsPage
    },
    {
        path: "/enterprise/pnls/create/:workspaceId/:strategyId/:templateId?",
        component: PnlCreatePage
    },
    {
        path: "/enterprise/pnls/edit/:workspaceId/:strategyId/:pnlId",
        component: PnlEditPage
    },
]
